import { Injectable } from '@angular/core';
import { ApModalResult, ApModalService } from 'webcommon/core-ui';
import { FindControlDeleteItemResultDto, IColumnPk } from 'webcommon/shared';
import { FcMergeItemModalComponent } from './fc-merge-item-modal.component';

@Injectable({
  providedIn: 'root',
})
export class FcMergeItemModalService{
  constructor(
    private apModalService: ApModalService,
  ) {}

    openModal(
      findControlBehaviorId: string,
      findControlBehaviorName: string,
      primaryKeyColumnName: string,
      dataItem: IColumnPk,
    ): Promise<ApModalResult<FindControlDeleteItemResultDto>> {
      const initialState = {
        findControlBehaviorId,
        findControlBehaviorName,
        primaryKeyColumnName,
        dataItem,
      };

      const p = this.apModalService.showComponentModal(FcMergeItemModalComponent, {
        class: 'emds-modal-small',
        ignoreBackdropClick: true,
        initialState,
      });

      return p;
    }
}
